<template>
  <v-dialog
    :value="shown"
    persistent
    max-width="450"
    @click:outside="hideModal"
    @keydown.esc="hideModal"
  >
    <div class="login">
      <div class="card-head">
        <v-btn
          icon
          dark
          @click="hideModal"
          class="hide-button"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h2>Password recovery - Step 1</h2>
      </div>
      <div v-if="!isSuccess" class="body">
        <div class="inputs">
          <v-text-field
            v-model="email"
            label="Email"
            filled
            :rules="rules.required.concat(rules.email)"
            @keyup.enter="send"
          ></v-text-field>
        </div>
        <v-alert
          v-if="errorMessage"
          text
          type="error"
          class="pr-10"
        >
          {{ errorMessage }}
        </v-alert>
        <div class="controls">
          <v-btn
            x-large
            color="#f0b323"
            @click="login"
            :disabled="!email || isLoading"
          >
          Recover Password
          </v-btn>
          <a @click="showLogin">Sign in</a>
        </div>
      </div>
      <div v-if="isSuccess" class="success-block">
        <p style="color: #666;">An email has been sent to {{ this.email }}, please follow instructions in that email.</p>
        <v-btn @click="hideModal" color="#f0b323" class="mt-5">OK</v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'recovery-modal',
  props: {
    shown: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      isSuccess: false,
      email: '',
      errorMessage: '',
      valid: true,
      rules: {
        required: [
          value => !!value || 'Required'
        ],
        email: [
          value => value.length >= 2 || 'Minimum 2 characters'
        ]
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('hide')
    },
    showLogin () {
      this.$emit('login')
    },
    login () {
      this.isLoading = true
      this.errorMessage = ''
      api.resetPassword({ login: this.email, path: `${window.location.origin}/reset-password` })
        .then(res => {
          this.isLoading = false
          this.isSuccess = true
        })
        .catch(err => {
          this.isLoading = false
          this.errorMessage = err.response
            ? err.response.data.message
            : err.message
        })
    }
  }
}
</script>

<style scoped lang="scss">
.hide-button {
  position: absolute;
  top: 30px;
  right: 30px;
}
.login {
  background: #FFFFFF;
  box-shadow: 0px 23px 28px rgba(0, 0, 0, 0.213768);
  border-radius: 7px;
}
.success-block {
  background: #FFFFFF;
  box-shadow: 0px 23px 28px rgba(0, 0, 0, 0.213768);
  border-radius: 7px;
  padding: 55px;
}
.card-head {
  position: relative;
  background: #18305A;
  height: 200px;
  display: flex;
  align-items: flex-end;
  padding-left: 55px;
  padding-right: 55px;
  h2 {
    color: #fff;
    padding-bottom: 30px;
  }
}
.inputs {
  padding: 55px;
}
.controls {
  display: flex;
  justify-content: space-between;
  padding: 20px 55px 50px;
  align-items: center;
}
</style>
